// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"e221cb90","170":"cc7cd7a5","243":"31bd4d57","377":"1d23ba86","397":"fa8ab628","582":"bab2e9cc","647":"c9928be3","660":"143de14e","787":"3220f3d3","966":"48381479","975":"12f9281e"}[chunkId] + ".chunk.js";
};